// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1ZMUE","infoBtn":"quickbooks_infoBtn__mEwG_","formBox":"quickbooks_formBox__22so4","formFooter":"quickbooks_formFooter__3R4XJ"};